/**
 * Early-Bird-Aktion — Anzeige-Konfiguration für die Pricing-Views
 * (Landing PricingSection + CreditsView).
 *
 * ⚠️ DEMO-MOCKUP: `takenSpots` ist ein fest gewählter Demo-Wert und
 * `priceFactor` ein fiktiver Anker. VOR einem Live-Gang muss beides durch
 * echte Daten gedeckt sein (takenSpots aus der DB, Streichpreis = tatsächlich
 * verlangter bzw. verbindlich künftiger Listenpreis) — sonst wettbewerbswidrig
 * (UWG, fiktive Streichpreise / falsche Knappheit). Bis dahin: enabled nur
 * für Demos auf true.
 */

export const EARLY_BIRD = {
  enabled: true,
  /** Plätze insgesamt */
  totalSpots: 50,
  /** DEMO: fest gewählter Zählerstand — vor Live-Gang durch echten Count ersetzen */
  takenSpots: 41,
  /** Streichpreis-Faktor (2 = "50 % Rabatt") */
  priceFactor: 2,
  /** Rabatt-Label, muss zu priceFactor passen */
  discountLabel: '-50 %',
} as const;

export const earlyBirdSpotsLeft = (): number =>
  Math.max(0, EARLY_BIRD.totalSpots - EARLY_BIRD.takenSpots);

export const earlyBirdProgressPercent = (): number =>
  Math.min(100, Math.round((EARLY_BIRD.takenSpots / EARLY_BIRD.totalSpots) * 100));

/** Fiktiver "regulärer" Preis (Streichpreis) zu einem Aktionspreis */
export const earlyBirdOriginalCents = (cents: number): number =>
  cents * EARLY_BIRD.priceFactor;
